/**
 * The hosted Zendesk "submit a request" form. Several places hand a buyer off to it with fields
 * prefilled in the query string, so the base and the builder live here rather than in whichever
 * feature needed them first.
 */
export const ZENDESK_NEW_REQUEST_URL =
  'https://revshop.zendesk.com/hc/en-us/requests/new';

/**
 * A request-form URL carrying prefills. Zendesk reads `ticket_form_id` for which form to open and
 * `tf_<field>` for what to put in it -- `tf_subject`, `tf_description`, or a custom field's id.
 */
export const zendeskRequestUrl = (params: Record<string, string>): string =>
  `${ZENDESK_NEW_REQUEST_URL}?${new URLSearchParams(params).toString()}`;
